import isAbsolutePositioning from './isAbsolutePositioning'
import isBodyElement from './isBodyElement'
import isDocumentElement from './isDocumentElement'
import isOverflowSet from './isOverflowSet'

const getScrollableParents = (
    element: HTMLElement,
    containers: Set<HTMLElement | Window> = new Set<HTMLElement | Window>()
) => {
    if (isDocumentElement(element) || isBodyElement(element)) {
        containers.add(window)
    } else {
        const computedStyle = window.getComputedStyle(element)
        if (
            isOverflowSet(computedStyle.overflow) ||
            isOverflowSet(computedStyle.overflowX) ||
            isOverflowSet(computedStyle.overflowY)
        ) {
            if (!isAbsolutePositioning(element)) {
                containers.add(element)
            }
        }
    }
    if (element.parentNode) {
        getScrollableParents(element.parentNode as HTMLElement, containers)
    }
    return containers
}

export default getScrollableParents
